import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import { applyDocumentDirection } from './useTar'
import { resolveInitialLanguage } from './resolveInitialLanguage'

// Import translation resources
import enTranslations from './locales/en.json'
import enCompanyTranslations from './locales/en-company.json'
import enSchoolTranslations from './locales/en-school.json'
import heTranslations from './locales/he.json'
import heCompanyTranslations from './locales/he-company.json'
import heSchoolTranslations from './locales/he-school.json'
import deTranslations from './locales/de.json'
import deCompanyTranslations from './locales/de-company.json'
import deSchoolTranslations from './locales/de-school.json'

const resources = {
  en: {
    translation: enTranslations,
    company: enCompanyTranslations,
    school: enSchoolTranslations,
  },
  he: {
    translation: heTranslations,
    company: heCompanyTranslations,
    school: heSchoolTranslations,
  },
  de: {
    translation: deTranslations,
    company: deCompanyTranslations,
    school: deSchoolTranslations,
  },
} as const

if (i18n.isInitialized) {
  // HMR re-evaluation: swap resource bundles in place, preserve current language.
  // Without this, editing a locale JSON would re-run init() and reset lng back to 'en'.
  for (const lng of Object.keys(resources) as Array<keyof typeof resources>) {
    for (const ns of Object.keys(resources[lng]) as Array<keyof (typeof resources)[typeof lng]>) {
      i18n.addResourceBundle(lng, ns, resources[lng][ns], true, true)
    }
  }
  // Nudge react-i18next subscribers to re-render with the refreshed strings.
  void i18n.changeLanguage(i18n.language)
} else {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng: resolveInitialLanguage(),
      fallbackLng: 'en', // Fallback language
      // debug: process.env['NODE_ENV'] === 'development',

      interpolation: {
        escapeValue: false, // React already does escaping
      },

      // Namespace configuration
      defaultNS: 'translation',
      ns: ['translation', 'company', 'school'],

      // React i18next options
      react: {
        useSuspense: false, // Disable suspense for better error handling
      },
    })
    .then(() => {
      applyDocumentDirection(i18n.language)
    })
}

if (import.meta.hot) {
  // Stop HMR propagation at this module so consumers don't remount when a locale changes.
  import.meta.hot.accept()
}

export default i18n
